import axios from "axios";

export const GET_CHATBOT_QA = "GET_CHATBOT_QA";
export const ADD_CHATBOT_QA = "ADD_CHATBOT_QA";
export const DELETE_CHATBOT_QA = "DELETE_CHATBOT_QA";
export const UPDATE_CHATBOT_QA = "UPDATE_CHATBOT_QA";
export const GET_QUESTIONS_EN_ATTENTE = "GET_QUESTIONS_EN_ATTENTE";
export const DELETE_QUESTION_EN_ATTENTE = "DELETE_QUESTION_EN_ATTENTE";
export const REPONDRE_QUESTION_EN_ATTENTE = "REPONDRE_QUESTION_EN_ATTENTE";
export const GET_CHATBOT_STATS = "GET_CHATBOT_STATS";

export const getChatbotStats = () => async (dispatch) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/chatbot/stats`,
      { withCredentials: true }
    );
    dispatch({
      type: GET_CHATBOT_STATS,
      payload: res.data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const getChatbotQA = () => async (dispatch) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/chatbot/qa/`,
      { withCredentials: true }
    );
    dispatch({
      type: GET_CHATBOT_QA,
      payload: res.data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const addChatbotQA = (question, reponse, category) => {
  return (dispatch) => {
    return axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/api/chatbot/qa/`,
      withCredentials: true,
      data: {
        question: question,
        reponse: reponse,
        category: category,
      },
    })
      .then((res) => {
        dispatch({
          type: ADD_CHATBOT_QA,
          payload: {
            question: question,
            reponse: reponse,
            category: category,
          },
        });
      })
      .catch((error) => console.error(error));
  };
};

export const deleteChatbotQA = (id) => {
  return (dispatch) => {
    return axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/chatbot/qa/${id}`,
      withCredentials: true,
    })
      .then((res) => {
        dispatch({ type: DELETE_CHATBOT_QA, payload: { id } });
      })
      .catch((error) => console.error(error));
  };
};

export const updateChatbotQA = (id, question, reponse, category) => {
  return (dispatch) => {
    return axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}/api/chatbot/qa/${id}`,
      withCredentials: true,
      data: {
        question: question,
        reponse: reponse,
        category: category,
      },
    })
      .then((res) => {        dispatch({
          type: UPDATE_CHATBOT_QA,
          payload: {
            id: id,
            question: question,
            reponse: reponse,
            category: category,
          },
        });
      })
      .catch((error) => console.error(error));
  };
};

// Actions pour les questions en attente
export const getQuestionsEnAttente = () => async (dispatch) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/chatbot/questions-en-attente`,
      { withCredentials: true }
    );
    dispatch({
      type: GET_QUESTIONS_EN_ATTENTE,
      payload: res.data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const repondreQuestionEnAttente = (id, reponse, category) => {
  return (dispatch) => {
    return axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/api/chatbot/questions-en-attente/${id}/repondre`,
      withCredentials: true,
      data: { reponse: reponse, category: category },
    })
      .then((res) => {
        dispatch({
          type: REPONDRE_QUESTION_EN_ATTENTE,
          payload: id,
        });
      })
      .catch((error) => console.error(error));
  };
};

export const deleteQuestionEnAttente = (id) => {
  return (dispatch) => {
    return axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/chatbot/questions-en-attente/${id}`,
      withCredentials: true,
    })
      .then((res) => {
        dispatch({ type: DELETE_QUESTION_EN_ATTENTE, payload: id });
      })
      .catch((error) => console.error(error));
  };
};
